import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";

const BreadcrumbTrail = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <nav aria-label="Breadcrumb" style={{ marginBottom: "0.9rem" }}>
      <ol
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.45rem",
          flexWrap: "wrap",
          padding: "0.45rem 0.6rem",
          margin: 0,
          listStyle: "none",
          borderRadius: "999px",
          background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
          border: "1px solid var(--color-border, #e2e8f0)",
          boxShadow: "none",
        }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li
              key={`${item.label}-${index}`}
              style={{ display: "inline-flex", alignItems: "center", gap: "0.45rem" }}
            >
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  style={{
                    color: "#334155",
                    fontSize: "0.82rem",
                    fontWeight: 600,
                    textDecoration: "none",
                    padding: "0.2rem 0.55rem",
                    borderRadius: "999px",
                    background: "#f1f5f9",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  style={{
                    color: isLast ? "#0f172a" : "#64748b",
                    fontSize: "0.82rem",
                    fontWeight: isLast ? 700 : 600,
                    padding: "0.2rem 0.15rem",
                    maxWidth: "280px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={item.label}
                >
                  {item.label}
                </span>
              )}

              {!isLast && <FiChevronRight size={13} color="#94a3b8" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbTrail;
